import { AnalyticsService } from 'src/Analytics/AnalyticsService';

export const updateAnalyticsForCustomerUsers = (email) => {
  const category = window.location.href.replace(window.location.origin, '');
  let catName = category.replace('/', '');
  catName = catName.includes('/') ? catName.split('/') : catName;

  const digitalData = {
    page: {
      pageInfo: {
        domain: document.domain,
        location: document.location,
        pageName: 'Customer',
        siteSection: 'Customer',
        pageURL: document.URL,
      },
      category: {
        primaryCategory: Array.isArray(catName) ? catName[0] : catName,
        pageType: document.domain,
        subCategory:
          Array.isArray(catName) && catName.length > 1 ? catName[1] : '',
      },
    },
    user: {
      profile: {
        profileInfo: {
          loginStatus: 'logged in',
          profileID: email,
        },
      },
    },
  };

  AnalyticsService.updateDigitalData(digitalData);
  AnalyticsService.trackEvent('setAnalyticsVariables');
  AnalyticsService.trackEvent('pageLoaded');
};

export const updateAnalyticsForAccountUsers = (email) => {
  const category = window.location.href.replace(window.location.origin, '');
  let catName = category.replace('/', '');
  catName = catName.includes('/') ? catName.split('/') : catName;

  const digitalData = {
    page: {
      pageInfo: {
        domain: document.domain,
        location: document.location,
        pageName: 'People',
        siteSection: 'People',
        pageURL: document.URL,
      },
      category: {
        primaryCategory: Array.isArray(catName) ? catName[0] : catName,
        pageType: document.domain,
        subCategory:
          Array.isArray(catName) && catName.length > 1 ? catName[1] : '',
      },
    },
    user: {
      profile: {
        profileInfo: {
          loginStatus: 'logged in',
          profileID: email,
        },
      },
    },
  };

  AnalyticsService.updateDigitalData(digitalData);
  AnalyticsService.trackEvent('setAnalyticsVariables');
  AnalyticsService.trackEvent('pageLoaded');
};

export const updateErrorAnalytics = () => {
  const digitalData = {
    error: {
      errorMessage: 'Could not open meeting. Try again.',
      errorType: 'Pop-up Banner',
    }
  };

  AnalyticsService.updateDigitalData(digitalData);
  AnalyticsService.trackEvent('setAnalyticsVariables');
  AnalyticsService.trackEvent('error_tracking');
};
